module.exports = "<div data-component=\"warning\" [class.error]=\"type ==='error'\" [class.warning]=\"type ==='warning'\">\n\t<i class=\"material-icons ico-success\" *ngIf=\"type === 'success'\">check_box</i>\n\t<i class=\"material-icons ico-error\" *ngIf=\"type === 'error'\">error</i>\n\t<i class=\"material-icons ico-warning\" *ngIf=\"type === 'warning'\">check_box</i>\n\t<p>{{message}}</p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/shared/warning/warning.component.html
// module id = ../../../../../src/app/shared/warning/warning.component.html
// module chunks = main